import { useMutation } from "@apollo/client";
import { REMOVE_COMPANY_DOCUMENT_CONFIRMATION } from "../api/remove-company-document-confirmation";
import { FieldsType } from "./types";
import { InternalRefetchQueriesInclude } from "@apollo/client/core/types";

export function useRemoveCompanyDocumentConfirmation() {
  const [removeConfirmation, { loading }] = useMutation(
    REMOVE_COMPANY_DOCUMENT_CONFIRMATION,
  );

  const remove = async (
    variables: FieldsType,
    refetchQueries?: InternalRefetchQueriesInclude,
  ) => {
    await removeConfirmation({ variables, refetchQueries });
  };

  return {
    remove,
    loading,
  };
}
